import { Tale, TaleStatus, TalesResponse } from '@binhatch/servicetale-api';

import { userApi, workshopApi } from '@/integrations/api';
import { delay } from './delay';
import { fuzzySearch } from './fuzzySearch';
import { PaginatedOptions, getPageResults } from './pagination';

export const tales: Tale[] = [
  {
    id: '1',
    workshopId: '1',
    status: TaleStatus.InProgress,
    media: {},
    carId: '',
    incomplete: [],
    completed: []
  }
];

export const findTales = async ({
  workshopId,
  status,
  search,
  token
}: {
  workshopId?: string;
  status?: TaleStatus;
  search?: string;
} & PaginatedOptions): Promise<TalesResponse> => {
  const result = workshopId
    ? await workshopApi.listWorkshopTales(workshopId, status, undefined, search, token)
    : await userApi.listUserTales(status, undefined, search, token);

  return result.data;

  await delay(1000);

  const { items, ...page } = getPageResults(
    (search ? fuzzySearch(tales, () => [], search) : tales).filter((tale) => !status || tale.status === status),
    token,
    10
  );

  return { tales: items, ...page };
};
